module.exports = __webpack_public_path__ + "img/pr-1.2d245ea7.png";